// Core Modules
import React from 'react';
import {Link} from 'react-router-dom';

const Sidebar = () => {

    return ( 
        <div className="sidebar" data-color="azure" data-background-color="white">
            <div className="logo">
                <span className="simple-text logo-normal">
                INSIGHT PLUS
                </span>
            </div>
            <div className="sidebar-wrapper">
                <ul className="nav">
                    <li className={ window.location.pathname === "/" ? "nav-item active" : "nav-item" }>
                        <Link className="nav-link" to="/">
                            <i className="material-icons">dashboard</i>
                            <p>Home</p>
                        </Link>
                    </li>
                    <li className={ window.location.pathname.includes("exams") ? "nav-item active" : "nav-item" }>
                        <Link className="nav-link" to="/exams">
                            <i className="material-icons">history_edu</i>
                            <p>Exams</p>
                        </Link>
                    </li>
                    <li className={ window.location.pathname.includes("results") ? "nav-item active" : "nav-item" }>
                        <Link className="nav-link" to="/results">
                            <i className="material-icons">analytics</i>
                            <p>Results</p>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>       
    );
}
 
export default Sidebar;